import { Navigate } from "react-router-dom";
import { useFeatureFlags } from "@/contexts/FeatureFlagsContext";

interface FeatureFlagGuardProps {
  flag: 'advancedProductSearch' | 'limitSearchByVin' | 'replacementProducts' | 'aiPartRecognition' | 'digitalAssets' | 'messageBoard' | 'demoMode' | 'aiFeatures';
  children: React.ReactNode;
}

export function FeatureFlagGuard({ flag, children }: FeatureFlagGuardProps) {
  const { isFeatureEnabled } = useFeatureFlags();

  if (!isFeatureEnabled(flag)) {
    return <Navigate to="/parts" replace />;
  }

  return <>{children}</>;
}
